/* eslint-disable no-loop-func */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import action from "../../../Redux Store/actions";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { supabase } from "../../../supabaseClient";
import { Box, Divider } from "@mui/material";
import ViewMore from "../../../Assets/Images/Common/viewMoreIcon.svg";
import { Card } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

//CSS
import cssClasses from "./ProjectMainPage.module.css";

//ICONS
import AddIcon from "@mui/icons-material/Add";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import DoneIcon from "@mui/icons-material/Done";
import eventIcon from "../../../Assets/Images/Common/Browser.svg";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

//SUBCOMPONENTS
import DropDown from "../../../Subcomponents/DropDown";
import SearchBar from "../../../Subcomponents/Search";
import Datagrid from "../../../Subcomponents/Datagrid";
import { DataGrid } from '@mui/x-data-grid';
import Button from "../../../Subcomponents/Button";
import ConfirmationAlert from "../../../Subcomponents/ConfirmationAlert";
import AddModal from "../../../Subcomponents/Modal/Modal";
import { Checkbox, FormGroup, List, Paper, Popover, Typography } from "@mui/material";
import {
  getAllProjects,
  getAssignedProjects,
  getProjectsForPagination,
} from "../../../Services/SustenanceService";
import { cloneDeep, debounce, groupBy, sortBy, uniqBy } from "lodash";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import ProgressBar from "../../../Subcomponents/ProgressBar";
import axios from "axios";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import { errorTost, successTost } from "../../../Services/Toast";
import Units from "../../../Subcomponents/Units";
import {
  AddProjectCollaterals,
  addInventory,
  addInventoryLogs,
  addProjectToDb,
  addWing,
  getProjectById,
  getProjectDataByProjectId,
} from "../../../Services/Project";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Dot from "../../Icons/Dot";
import InfiniteScroll from "react-infinite-scroll-component";
import { getInventoryByBuid, getWingByName } from "../../../Services/Inventory";
import { useSelector } from "react-redux";
import PlusIcon from "../../Icons/PlusIcon";
import { createFolderInDrive } from "../../../Services/Drive";


const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};
function Project() {
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("Latest First");
  const [Projects, setProjects] = useState([]);
  const [BURows, setBURows] = useState([]);
  const [inventory, setInventory] = useState(null);
  const [selectedWing, setSelectedWing] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [NoProjectFound, setNoProjectsFound] = useState(null);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState("");
  const [type, setType] = useState("");
  const [projectId, setProjectId] = useState();
  const [projectToSync, setProjectToSync] = useState();
  const [loadingStatus, setLoadingStatus] = useState(0);
  let loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const color_schema = {
    "Available": {
      color: "#027A48",
      background: "#D1FADF"
    },
    "Booked": {
      color: '#B42318',
      background: '#FEE4E2'
    },
    "Blocked": {
      color: '#6941C6',
      background: '#F4EBFF'
    },
    "Hold": {
      color: "#B54708",
      background: "#FEF0C7"
    },
  }

  function goToProject(projectId) {
    navigate(`/home/Projects/${projectId}`);
  }

  const ProjectColumns = [
    {
      field: 'action',
      headerName: '',
      width: 250,
      renderCell: (params) => {
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '3rem'
          }} className={cssClasses.actionDiv}>
            {loggedInUser?.roleId?.accessibleTabs?.Project?.['Edit']?.isAccessible && (
              <div>
                <Button
                  btnName={'Edit'}
                  style={{
                    borderRadius: '0.4rem',
                    backgroundColor: '#FFFFFF',
                    color: 'rgb(52, 64, 84)',
                    fontSize: '1.4rem',
                  }}
                  padding={'0.5rem 1rem'}
                  iconPosition={'left'}
                  clicked={() => { setMode("edit"); setSelectedProject(params.row) }}
                />
              </div>)}
            {loggedInUser?.roleId?.accessibleTabs?.Project?.['Sync']?.isAccessible && (

              <div>
                <Button
                  btnName={'Sync'}
                  style={{
                    borderRadius: '0.4rem',
                    backgroundColor: '#007FFF',
                    color: '#FFFFFF',
                    fontSize: '1.4rem',
                  }}
                  padding={'0.5rem 1rem'}
                  btnIcon={
                    <ArrowCircleUpIcon
                      style={{ width: '2rem', height: '2rem' }}
                    />
                  }
                  iconPosition={'left'}
                  clicked={() => { setProjectToSync(params.row); syncClick() }}
                />
              </div>)}
          </div>
        );
      },
    },
    {
      field: "",
      headerName: "Project Name",
      width: 400,
      renderCell: (params) => {
        return (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              cursor: "pointer",
            }}
            onClick={() => {
              if (loggedInUser?.roleId?.accessibleTabs?.Project?.['View Project Details']?.isAccessible) {
                goToProject(params.row.projectId);
              }
            }}
          >
            <div
              style={{
                background: params.row.isVJ === false ? "#1570EF" : "#FDB022",
                borderRadius: "50%",
                textAlign: "center",
              }}
            >
              <img
                style={{ margin: "0.8rem 1rem 0.4rem 1rem" }}
                src={eventIcon}
                alt=""
              />
            </div>
            <div>
              <p>{params.row.projectName}</p>
            </div>
            {/* <div>
              <LeadStatusChip label={params.row.type} icon={<Dot width={"0.5rem"} height={"0.5rem"} />} style={{ color: params.row.type === "VJ" ? "#027A48" : "#B42318", backgroundColor: params.row.type === "VJ" ? "#ECFDF3" : "#FEF3F2" }} />
            </div> */}
          </Box>
        );
      },
    },

    {
      field: "Status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            {/* {params.row.isCompleted === true ? ( */}
            {params.row.isPublished ? (
              <>
                <LeadStatusChip
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  label={"Published"}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              </>
            ) : (
              <LeadStatusChip
                style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                label={"Unpublished"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
          </>
        );
      },
    },
    {
      field: "companyName",
      headerName: "Company Name",
      width: 350,
      renderCell: (params) => <p>{params.row.companyName || "-"}</p>,
    },
    {
      field: "location",
      headerName: "Location",
      width: 650,
      renderCell: (params) => {
        return (
          <div>
            <p>{`${params.row.addressLine1} ${params.row.addressLine2} ${params.row.addressLine3 === null ? "" : params.row.addressLine3
              }`}</p>
          </div>
        );
      },
    },
  ];

  const landOwnerDBList = [
    { value: "YashOne | Hinjewadi", label: "YashOne | Hinjewadi" },
    { value: "YashOne Eternity", label: "YashOne Eternity" },
    { value: "Yashwin Infinity", label: "Yashwin Infinity" },
    { value: "Yashwin Supernova", label: "Yashwin Supernova" },
    { value: "YashOne | Hinjewadi", label: "YashOne | Hinjewadi" },
  ];

  const BUColumns = [
    {
      field: "radiobutton",
      headerName: "",
      width: 50,
      sortable: false,
      renderCell: (params) => (
        <Radio onChange={() => {
          // let arr = [...BURows]
          // arr.forEach((ele) => {
          //   if (ele.buId === params.row.buId) {
          //     ele.isSelected = true
          //   } else {
          //     ele.isSelected = false
          //   }
          // })
          // setBURows([...arr])
          setSelectedProject(params.row);
        }} checked={params.row.buId === selectedProject.buId} value={params.id} />
      ),
    },
    {
      field: "projectName",
      headerName: "Project Name",
      width: 400,
    },
    {
      field: "buId",
      headerName: "BU ID",
      width: 150,
    },
    {
      field: "city",
      headerName: "City",
      width: 150,
    },
    {
      field: "Location",
      headerName: "Location",
      width: 400,
      renderCell: (params) => (
        <>
          <p>{params.row.addressLine1},{params.row.addressLine2},{params.row.addressLine3}</p>
        </>
      ),
    },
  ];

  const wings = [
    {
      value: "Wing A",
      label: "Wing A",
      floors: [
        { value: "floor 1", label: "floor 1" },
        { value: "floor 1", label: "floor 2" },
        { value: "floor 1", label: "floor 3" },
      ],
    },
    { value: "Wing B", label: "Wing B" },
    { value: "Wing C", label: "Wing C" },
    { value: "Wing C", label: "Wing C" },
    { value: "Wing C", label: "Wing C" },
    { value: "Wing C", label: "Wing C" },
    { value: "Wing C", label: "Wing C" },
    { value: "Wing C", label: "Wing C" },
    { value: "Wing C", label: "Wing C" },
    { value: "Wing C", label: "Wing C" },
    { value: "Wing C", label: "Wing C" },
  ];

  const units = [
    { value: "101", label: "101" },
    { value: "101", label: "101" },
    { value: "101", label: "101" },
    { value: "101", label: "101" },
    { value: "101", label: "101" },
    { value: "101", label: "101" },
    { value: "101", label: "101" },
    { value: "101", label: "101" },
  ];
  const [selectedProject, setSelectedProject] = useState("");
  const [jdBuid, setJdBuid] = useState(null);
  const [openSyncAlert, setOpenSyncAlert] = useState(false);
  const [openAddProjectModal, setOpenAddProjectModal] = useState(false);
  const [openBUList, setOpenBUList] = useState(false);
  const [openLandownerDB, setOpenLandownerDB] = useState(false);
  const [openHierarchy, setOpenHierarchy] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [btnNameFlow, setBtnNameFlow] = useState("");
  const [flowControl, setFlowControl] = useState();
  const [allProject, setAllProject] = useState([]);
  const [ProjectsCount, setProjectsCount] = useState(0)
  useEffect(() => {
    dispatch(action.activeMenu("project"));
    setLoadingStatus(0);

    getAllProjectsFromServer(0, false, search, drpDownSelectedVal);
  }, [openHierarchy]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  // console.log(process.env)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  // const [selectionModel, setSelectionModel] = useState(radioChecked);
  // radioChecked = selectionModel;
  // const selectedRow = BURows.filter((item) => {
  //   return item.id === selectionModel[0];
  // });

  useEffect(() => {
    if (openAddProjectModal === false) {
      getAllProjectsFromServer(0, false, search, drpDownSelectedVal);
    }
  }, [openAddProjectModal]);

  // function pageChanged(e) {
  //   console.log(e);
  //   console.log("page---", e);
  //   setPageMaintain(e);
  //   if (pageNumber < e) {
  //     getMoreData(e);
  //     setPageNumber(e);
  //   }
  // }
  const syncClick = () => {
    setOpenSyncAlert(true);
  };
  const handleSelectDB = (e) => {
    // setOpenAddProjectModal(false);
    // setOpenBUList(true);
    // setBtnNameFlow('Save');
    // setFlowControl('vjDB');
    presentLoader()
    setActiveStep(1)
    // getAllProjects().then((resp) => {
    let arr = []
    // resp.data.forEach((ele) => { arr.push(ele.buId) })
    // axios.post(`${process.env.REACT_APP_PROJECTS_URL}getBusinessUnits`, { excludedUnits: arr }).then((bu) => {
    if (e === 'VJ') {
      setType("VJ")
      axios.post(`${process.env.REACT_APP_PROJECTS_URL}getBusinessUnits`, { excludedUnits: [] }).then((bu) => {
        console.log(bu.data.result)
        bu.data.result.forEach((ele, index) => { ele.key = index; ele.id = index; ele.show = true })
        setBURows(uniqBy([...bu.data.result], "buId"))
        dismissLoader()
      }).catch((err) => {
        dismissLoader()
        console.log(err)
      })
    } else {
      setType("Landowner")
      axios.post(`${process.env.REACT_APP_JDPROJECTS_URL}getBusinessUnits`, { excludedUnits: [] }).then((bu) => {
        console.log(bu.data.result)
        bu.data.result.forEach((ele, index) => { ele.key = index; ele.id = index; ele.show = true })
        setBURows(uniqBy([...bu.data.result], "buId"))
        dismissLoader()
      }).catch((err) => {
        dismissLoader()
        console.log(err)
      })
    }
    // }).catch((err) => {
    //   dismissLoader();
    //   console.log(err);
    // })
  };
  const navigate = useNavigate();
  function handleSubmit() {
    if (flowControl === "vjDB") {
      console.log("Saveee");
    } else if (flowControl === "landownerDB") {
      setOpenHierarchy(false);
      setOpenLandownerDB(true);
    }
  }

  function getAllProjectsFromServer(pageNumber, merge, search, drpDownSelectedVal) {
    // ! if loggedInUser is superadmin; show all projects
    if (loggedInUser.roleId.level === 1) {
      getProjectsForPagination(
        search,
        pageNumber * pageSize,
        pageNumber * pageSize + pageSize - 1,
        drpDownSelectedVal,
      ).then((response) => {
        console.log("Data", response)
        setProjectsCount(response.count)
        if (response.count > 0) {
          setNoProjectsFound(true);
        } else {
          setNoProjectsFound(false);
        }
        const ProjectArr = response.data.map((el, index) => ({
          ...el,
          id: el.projectId,
          index: index,
          show: true
        }));
        if (merge) {
          // if (loadingStatus !== 0) return;
          // setLoadingStatus(1);
          // if (response.count > response.length + Projects.length) {
          //   setLoadingStatus(0);
          //   setPageNumber(pageNumber + 1);
          // } else {
          //   setLoadingStatus(-1);
          //   setPageNumber(0);
          // }
          setProjects((pre) => [...pre, ...ProjectArr]);
        } else {
          // if (response.count > response.length) {
          //   setLoadingStatus(0);
          //   setPageNumber(1);
          // } else {
          //   setLoadingStatus(-1);
          //   setPageNumber(0);
          // }
          setProjects([...ProjectArr]);
        }
      })
        .catch((err) => {
          console.log(err);
        });
    } else {
      // ! if loggedInUser is not superadmin; show projects that are assigned to user
      getAssignedProjects(
        search,
        pageNumber * pageSize,
        pageNumber * pageSize + pageSize - 1,
        drpDownSelectedVal,
        loggedInUser.userId
      ).then((response) => {
        console.log("Data", response)
        setProjectsCount(response.count)
        if (response.count > 0) {
          setNoProjectsFound(true);
        } else {
          setNoProjectsFound(false);
        }
        // response = response.data.map((el, index) => ({
        //   ...el,
        //   id: el.projectId,
        //   index: index,
        //   show: true
        // }));
        let projects = [];
        response.data.forEach((proj) => {
          proj.projectId.id = proj.projectId.projectId;
          projects.push(proj.projectId)
        });

        if (merge) {
          // ! commented as this is handled by DataGrid itself
          // if (loadingStatus !== 0) return;
          // setLoadingStatus(1);
          // if (response.count > response.length + Projects.length) {
          //   setLoadingStatus(0);
          //   setPageNumber(pageNumber + 1);
          // } else {
          //   setLoadingStatus(-1);
          //   setPageNumber(0);
          // }
          setProjects((pre) => [...pre, ...projects]);
        } else {
          // if (response.count > response.length) {
          //   setLoadingStatus(0);
          //   setPageNumber(1);
          // } else {
          //   setLoadingStatus(-1);
          //   setPageNumber(0);
          // }
          setProjects([...projects]);
        }
      })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  useEffect(() => {
    if (mode === 'edit') {
      getInventory(2)
    }
  }, [selectedProject])

  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getAllProjectsFromServer(passPageNumber, true, search, drpDownSelectedVal);
  }

  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    getAllProjectsFromServer(pageNumber, false, e.target.value, drpDownSelectedVal);
  }, 800)

  function getInventory(num) {
    presentLoader()
    setProjectId(null)
    console.log(selectedProject)
    let currentType = selectedProject.type ? selectedProject.type : type
    let url = `${process.env.REACT_APP_PROJECTS_URL}getUnitsNew?buId=${selectedProject.buId}`
    getProjectById(selectedProject.buId, currentType).then((projectRes) => {
      if (projectRes.data.length === 0) {
        axios.get(url).then((units) => {
          console.log(units)
          setJdBuid(units.data.result.filter((e) => { return e.jdBuId }).length > 0 ? units.data.result.filter((e) => { return e.jdBuId })[0].jdBuId : null)
          if (projectRes.data.length > 0) {
            setProjectId(projectRes.data[0].projectId)
          }
          if (Object.keys(units.data).length === 0 || Object.keys(units.data.result).length === 0 || units.data.result.length === 0) {
            errorTost("Inventory not found")
            dismissLoader()
          } else {
            console.log(units.data.result)
            units.data.result.forEach((e) => {
              e.disabled = false
              e.isSelected = true
            })
            console.log(units.data.result.filter((e) => { return e.isSelected }))
            console.log(units.data.result.filter((e) => { return !e.isSelected }))
            let array = groupBy(units.data.result, 'wingName')
            Object.keys(array).forEach((ele) => {
              array[ele] = {
                isSelected: units.data.result.filter((e) => { return e.wingName === ele && e.isSelected === true }).length === 0 ? false : true,
                disabled: units.data.result.filter((e) => { return e.wingName === ele && e.isSelected === true }).length === 0 ? true : false,
                alreadyPresent: units.data.result.filter((e) => { return e.wingName === ele && e.isSelected === false }).length > 0 ? true : false,
                floors: groupBy(array[ele], 'floor')
              }
              Object.keys(array[ele].floors).forEach((floor) => {
                array[ele].floors[floor] = {
                  isSelected: units.data.result.filter((e) => { return e.wingName === ele && e.floor === floor && e.isSelected === true }).length === 0 ? false : true,
                  disabled: units.data.result.filter((e) => { return e.wingName === ele && e.floor === floor && e.isSelected === true }).length === 0 ? true : false,
                  alreadyPresent: units.data.result.filter((e) => { return e.wingName === ele && e.floor === floor && e.isSelected === false }).length > 0 ? true : false, units: sortBy(array[ele].floors[floor], 'unitNo')
                }
              })
            })
            console.log(array)
            setInventory(array)
            setSelectedWing(Object.keys(array)[0])
            setSelectedFloor(Object.keys(array[Object.keys(array)[0]].floors)[0])
            setActiveStep((pre) => { return pre + 1 })
            dismissLoader()
          }
        }).catch((err) => {
          console.log(err)
          errorTost("Inventory not found")
          dismissLoader()
        })
      } else {
        getInventoryByBuid(projectRes.data[0].projectId).then((resp) => {
          console.log(resp.data)
          axios.get(url).then((units) => {
            console.log(units)
            setJdBuid(units.data.result.filter((e) => { return e.jdBuId }).length > 0 ? units.data.result.filter((e) => { return e.jdBuId })[0].jdBuId : null)
            if (projectRes.data.length > 0) {
              setProjectId(projectRes.data[0].projectId)
            }
            if (Object.keys(units.data).length === 0 || Object.keys(units.data.result).length === 0 || units.data.result.length === 0) {
              errorTost("Inventory not found")
              dismissLoader()
            } else {
              console.log(units.data.result)
              units.data.result.forEach((e) => {
                if (resp.data.filter((ele) => { return ele.unitNo === e.unitNo && ele.wingId.wingName === e.wingName }).length > 0) {
                  e.disabled = true
                  e.isSelected = false
                } else {
                  e.disabled = false
                  e.isSelected = true
                }
              })
              console.log(units.data.result.filter((e) => { return e.isSelected }))
              console.log(units.data.result.filter((e) => { return !e.isSelected }))
              let array = groupBy(units.data.result, 'wingName')
              Object.keys(array).forEach((ele) => {
                array[ele] = {
                  isSelected: units.data.result.filter((e) => { return e.wingName === ele && e.isSelected === true }).length === 0 ? false : true,
                  disabled: units.data.result.filter((e) => { return e.wingName === ele && e.isSelected === true }).length === 0 ? true : false,
                  alreadyPresent: units.data.result.filter((e) => { return e.wingName === ele && e.isSelected === false }).length > 0 ? true : false,
                  floors: groupBy(array[ele], 'floor')
                }
                Object.keys(array[ele].floors).forEach((floor) => {
                  array[ele].floors[floor] = {
                    isSelected: units.data.result.filter((e) => { return e.wingName === ele && e.floor === floor && e.isSelected === true }).length === 0 ? false : true,
                    disabled: units.data.result.filter((e) => { return e.wingName === ele && e.floor === floor && e.isSelected === true }).length === 0 ? true : false,
                    alreadyPresent: units.data.result.filter((e) => { return e.wingName === ele && e.floor === floor && e.isSelected === false }).length > 0 ? true : false, units: sortBy(array[ele].floors[floor], 'unitNo')
                  }
                })
              })
              console.log(array)
              setInventory(array)
              setSelectedWing(Object.keys(array)[0])
              setSelectedFloor(Object.keys(array[Object.keys(array)[0]].floors)[0])
              if (num === 2) {
                setActiveStep(2)
                setOpenAddProjectModal(true)
              } else {
                setActiveStep((pre) => { return pre + 1 })
              }
              dismissLoader()
            }
          }).catch((err) => {
            console.log(err)
            errorTost("Inventory not found")
            dismissLoader()
          })
        })
      }
    })
  }

  useEffect(() => {
    if (inventory && inventory[selectedWing]) {
      setSelectedFloor(Object.keys(inventory[selectedWing].floors)[0])
    }
  }, [selectedWing]);

  function saveInventory() {
    console.log(jdBuid)
    setMode('')
    let obj = cloneDeep(selectedProject)
    delete obj.key
    delete obj.id
    delete obj.addressLine4
    delete obj.show
    let currentType = selectedProject.type ? selectedProject.type : type
    console.log(currentType)
    presentLoader()
    supabase.from('InventoryStatus').select('*').eq('status', "Available").then(async (statusRes) => {
      if (projectId && projectId !== '') {
        for (const wing of Object.keys(inventory)) {
          // Object.keys(inventory).forEach((wing, index) => {
          console.log(wing)
          console.log(inventory)
          if (inventory[wing].isSelected === true && inventory[wing].alreadyPresent === false) {
            await addWing({ wingName: wing, projectId: projectId, displayName: wing }).then(async (wingResp) => {
              console.log(wingResp)
              for (const floor of Object.keys(inventory[wing].floors)) {
                // Object.keys(inventory[wing].floors).forEach((floor, floorIndex) => {
                let arr = cloneDeep([...inventory[wing].floors[floor].units])
                // let arrToAdd = []
                for (const ele of arr) {
                  // arr.forEach((arr, myindex) => {
                  if ((ele.unitNo) && ele.isSelected === true && ele.disabled === false) {
                    await supabase.from('InventoryType').select('*').eq('type', ele.unitType).then(async (typeRes) => {
                      if (typeRes.data.length === 0) {
                        await supabase.from('InventoryType').insert({ type: ele.unitType }).select().then(async (typeRes) => {
                          console.log('-----------------------', typeRes)
                          let obj = { displayUnitType: ele.flatType, farvisionUnitId: ele.UnitId, farvisionStatus: ele.UnitStatus, inventoryTypeId: typeRes.data[0].inventoryTypeId, inventoryStatusId: statusRes.data[0].inventoryStatusId, unitOf: ele.unitOf, projectId: projectId, wingId: wingResp[0].wingId, floorNo: ele.floor, chargeableArea: ele.chargeableArea, saleableArea: ele.saleableArea, unitNo: (ele.unitNo), view: ele.view }
                          await addInventory(obj).then(async (unitResp) => {
                            await addInventoryLogs(unitResp[0]).then((resp) => {
                              console.log(unitResp)
                              // if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                              //   dismissLoader()
                              //   successTost("Project Added successfully")
                              //   setOpenAddProjectModal(false)
                              //   setActiveStep(0)
                              //   setSelectedWing('')
                              //   setSelectedFloor('')
                              //   setSelectedProject('')
                              // }
                            })
                          }).catch((err) => {
                            // dismissLoader()
                          })
                        })
                      } else {
                        let obj = { displayUnitType: ele.flatType, farvisionUnitId: ele.UnitId, farvisionStatus: ele.UnitStatus, inventoryTypeId: typeRes.data[0].inventoryTypeId, inventoryStatusId: statusRes.data[0].inventoryStatusId, unitOf: ele.unitOf, projectId: projectId, wingId: wingResp[0].wingId, floorNo: ele.floor, chargeableArea: ele.chargeableArea, saleableArea: ele.saleableArea, unitNo: (ele.unitNo), view: ele.view }
                        await addInventory(obj).then(async (unitResp) => {
                          await addInventoryLogs(unitResp[0]).then((resp) => {
                            console.log(unitResp)
                            // if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                            //   dismissLoader()
                            //   successTost("Project Added successfully")
                            //   setOpenAddProjectModal(false)
                            //   setActiveStep(0)
                            //   setSelectedWing('')
                            //   setSelectedFloor('')
                            //   setSelectedProject('')
                            // }
                          })
                        }).catch((err) => {
                          // dismissLoader()
                        })
                      }
                    })
                  }
                  // else {
                  //   if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                  //     dismissLoader()
                  //     successTost("Project Added successfully")
                  //     setOpenAddProjectModal(false)
                  //     setActiveStep(0)
                  //     setSelectedWing('')
                  //     setSelectedFloor('')
                  //     setSelectedProject('')
                  //   }
                  // }
                  // })
                }
                // })
              }
            }).catch((err) => {
              // dismissLoader()
            })
          } else {
            getWingByName(projectId, wing).then((wingResp) => {
              for (const floor of Object.keys(inventory[wing].floors)) {
                // Object.keys(inventory[wing].floors).forEach((floor, floorIndex) => {
                let arr = cloneDeep([...inventory[wing].floors[floor].units])
                // let arrToAdd = []
                for (const ele of arr) {
                  // arr.forEach((ele, myindex) => {
                  if ((ele.unitNo) && ele.isSelected === true && ele.disabled === false) {
                    supabase.from('InventoryType').select('*').eq('type', ele.unitType).then((typeRes) => {
                      if (typeRes.data.length === 0) {
                        supabase.from('InventoryType').insert({ type: ele.unitType }).select().then((typeRes) => {
                          console.log('-----------------------', typeRes)
                          let obj = { displayUnitType: ele.flatType, farvisionUnitId: ele.UnitId, farvisionStatus: ele.UnitStatus, inventoryTypeId: typeRes.data[0].inventoryTypeId, inventoryStatusId: statusRes.data[0].inventoryStatusId, unitOf: ele.unitOf, projectId: projectId, wingId: wingResp.data[0].wingId, floorNo: ele.floor, chargeableArea: ele.chargeableArea, saleableArea: ele.saleableArea, unitNo: (ele.unitNo), view: ele.view }
                          addInventory(obj).then((unitResp) => {
                            addInventoryLogs(unitResp[0]).then((resp) => {
                              console.log(unitResp)
                              // if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                              //   dismissLoader()
                              //   successTost("Project Added successfully")
                              //   setOpenAddProjectModal(false)
                              //   setActiveStep(0)
                              //   setSelectedWing('')
                              //   setSelectedFloor('')
                              //   setSelectedProject('')
                              // }
                            })
                          }).catch((err) => {
                            // dismissLoader()
                          })
                        })
                      } else {
                        let obj = { displayUnitType: ele.flatType, farvisionUnitId: ele.UnitId, farvisionStatus: ele.UnitStatus, inventoryTypeId: typeRes.data[0].inventoryTypeId, inventoryStatusId: statusRes.data[0].inventoryStatusId, unitOf: ele.unitOf, projectId: projectId, wingId: wingResp.data[0].wingId, floorNo: ele.floor, chargeableArea: ele.chargeableArea, saleableArea: ele.saleableArea, unitNo: (ele.unitNo), view: ele.view }
                        addInventory(obj).then((unitResp) => {
                          addInventoryLogs(unitResp[0]).then((resp) => {
                            console.log(unitResp)
                            // if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                            //   dismissLoader()
                            //   successTost("Project Added successfully")
                            //   setOpenAddProjectModal(false)
                            //   setActiveStep(0)
                            //   setSelectedWing('')
                            //   setSelectedFloor('')
                            //   setSelectedProject('')
                            // }
                          })
                        }).catch((err) => {
                          // dismissLoader()
                        })
                      }
                    })
                  }
                  // else {
                  //   if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                  //     dismissLoader()
                  //     successTost("Project Added successfully")
                  //     setOpenAddProjectModal(false)
                  //     setActiveStep(0)
                  //     setSelectedWing('')
                  //     setSelectedFloor('')
                  //     setSelectedProject('')
                  //   }
                  // }
                  // })
                }
                // })
              }
            })
          }
          // })
        }
        dismissLoader()
        successTost("Project Added successfully")
        setOpenAddProjectModal(false)
        setActiveStep(0)
        setSelectedWing('')
        setSelectedFloor('')
        setSelectedProject('')
      } else {
        obj.type = type
        obj.jdBuid = jdBuid
        await addProjectToDb(obj).then(async (projectResp) => {

          for (const wing of Object.keys(inventory)) {
            // Object.keys(inventory).forEach((wing, index) => {
            console.log(wing)
            console.log(inventory)
            if (inventory[wing].isSelected === true) {
              await addWing({ wingName: wing, projectId: projectResp[0].projectId, displayName: wing }).then(async (wingResp) => {
                console.log(wingResp)
                for (const floor of Object.keys(inventory[wing].floors)) {
                  // Object.keys(inventory[wing].floors).forEach((floor, floorIndex) => {
                  let arr = cloneDeep([...inventory[wing].floors[floor].units])
                  // let arrToAdd = []
                  for (const ele of arr) {
                    // arr.forEach((ele, myindex) => {
                    if ((ele.unitNo) && ele.isSelected === true) {
                      await supabase.from('InventoryType').select('*').eq('type', ele.unitType).then(async (typeRes) => {
                        if (typeRes.data.length === 0) {
                          await supabase.from('InventoryType').insert({ type: ele.unitType }).select().then(async (typeRes) => {
                            console.log('-----------------------', typeRes)
                            let obj = { displayUnitType: ele.flatType, farvisionUnitId: ele.UnitId, farvisionStatus: ele.UnitStatus, inventoryTypeId: typeRes.data[0].inventoryTypeId, inventoryStatusId: statusRes.data[0].inventoryStatusId, unitOf: ele.unitOf, projectId: projectResp[0].projectId, wingId: wingResp[0].wingId, floorNo: ele.floor, chargeableArea: ele.chargeableArea, saleableArea: ele.saleableArea, unitNo: (ele.unitNo), view: ele.view }
                            await addInventory(obj).then(async (unitResp) => {
                              await addInventoryLogs(unitResp[0]).then((resp) => {
                                console.log(unitResp)
                                // if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                                //   dismissLoader()
                                //   successTost("Project Added successfully")
                                //   setOpenAddProjectModal(false)
                                //   setActiveStep(0)
                                //   setSelectedWing('')
                                //   setSelectedFloor('')
                                //   setSelectedProject('')
                                // }
                              })
                            }).catch((err) => {
                              // dismissLoader()
                            })
                          })
                        } else {
                          let obj = { displayUnitType: ele.flatType, farvisionUnitId: ele.UnitId, farvisionStatus: ele.UnitStatus, inventoryTypeId: typeRes.data[0].inventoryTypeId, inventoryStatusId: statusRes.data[0].inventoryStatusId, unitOf: ele.unitOf, projectId: projectResp[0].projectId, wingId: wingResp[0].wingId, floorNo: ele.floor, chargeableArea: ele.chargeableArea, saleableArea: ele.saleableArea, unitNo: (ele.unitNo), view: ele.view }
                          await addInventory(obj).then(async (unitResp) => {
                            await addInventoryLogs(unitResp[0]).then((resp) => {
                              console.log(unitResp)
                              // if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                              //   dismissLoader()
                              //   successTost("Project Added successfully")
                              //   setOpenAddProjectModal(false)
                              //   setActiveStep(0)
                              //   setSelectedWing('')
                              //   setSelectedFloor('')
                              //   setSelectedProject('')
                              // }
                            })
                          }).catch((err) => {
                            // dismissLoader()
                          })
                        }
                      })
                    }
                    // else {
                    //   if ((index === Object.keys(inventory).length - 1) && (myindex === arr.length - 1) && (floorIndex === Object.keys(inventory[wing].floors).length - 1)) {
                    //     dismissLoader()
                    //     successTost("Project Added successfully")
                    //     setOpenAddProjectModal(false)
                    //     setActiveStep(0)
                    //     setSelectedWing('')
                    //     setSelectedFloor('')
                    //     setSelectedProject('')
                    //   }
                    // }
                    // })
                  }
                  // })
                }
              }).catch((err) => {
                // dismissLoader()
              })
            }
            // else {
            //   if (index === Object.keys(inventory).length - 1) {
            //     dismissLoader()
            //     successTost("Project Added successfully")
            //     setOpenAddProjectModal(false)
            //     setActiveStep(0)
            //     setSelectedWing('')
            //     setSelectedFloor('')
            //     setSelectedProject('')
            //   }
            // }
            // })
          }
          presentLoader();
            createFolderInDrive(
              `${ projectResp[0].projectName}`
            )
              .then((resp) => {
                if (resp) {
                  let obj = {
                    projectId:  projectResp[0]?.projectId,
                    createdBy:  projectResp[0]?.userId,
                    fileUrl: resp?.data?.Key,
                    fileType: "folder",
                    fileName:  projectResp[0]?.projectName,
                    parentId: null,
                  };
                  AddProjectCollaterals(obj)
                    .then((resp) => {
                      dismissLoader()
                    })
                    .catch((err) => {
                      dismissLoader();
                      errorTost(err?.message);
                    });
                }
              })
              .catch((err) => {
                errorTost(err?.message);
                dismissLoader();
              });;
          dismissLoader()
          successTost("Project Added successfully")
          setOpenAddProjectModal(false)
          setActiveStep(0)
          setSelectedWing('')
          setSelectedFloor('')
          setSelectedProject('')
        }).catch((err) => {
          // dismissLoader()
        })
      }

    })
  }

  function syncUnitStatus(e) {
    if (e === 'confirmed') {
      presentLoader()
      axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}units/updateFarvisionStatus`, { project: projectToSync }).then((resp) => {
        // axios.post(`http://localhost:8000/units/updateFarvisionStatus`, { project: projectToSync }).then((resp) => {
        console.log(resp)
        if (resp.data.success) {
          successTost("Project sync running in background. Check after sometime!")
          dismissLoader()
          setOpenSyncAlert(false)
        } else {
          errorTost("Something went wrong ! Please try again later")
          dismissLoader()
          setOpenSyncAlert(false)
        }
      }).catch((err) => {
        errorTost("Something went wrong ! Please try again later")
        dismissLoader()
        setOpenSyncAlert(false)
      })
    } else {
      setOpenSyncAlert(false)
    }
  }

  return (
    <div className={cssClasses.wrapperPage}>
      <ConfirmationAlert
        open={openSyncAlert}
        close={() => setOpenSyncAlert(false)}
        title="Sync Alert!"
        subTitle="Are you sure you want to sync?"
        returnRespButton="Yes"
        confirm={(e) => {
          syncUnitStatus(e)
        }}
        buttonTitle="No"
      />
      {/* //! move add project modal code in modal */}
      <AddModal
        open={openAddProjectModal}
        close={() => setOpenAddProjectModal(false)}
        title={'Add Project'}
        // activeStep === 0 ? 'Choose the preferred BU database to add a new project from' :
        subTitle={activeStep === 1 ? `${BURows.filter((e) => { return e.show }).length} Projects fetched from VJ Database, Select the Project to be added` : 'Select the hierarchy of the project'}
        content={
          <>
            {mode !== 'edit' &&
              <div style={{ width: "100%", marginBottom: "3rem" }}>
                {/* { title: "Select Database" }, */}
                <ProgressBar activeStep={activeStep} steps={[ { title: "Select Project" }, { title: "Select Inventory" }]} />
              </div>
            }
            {/* {activeStep === 0 &&
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "2rem",
                  justifyContent: "center",
                }}
              >
                <div
                  className={cssClasses.AddProjectModalContainer}
                  onClick={() => handleSelectDB("VJ")}
                >
                  <div className={cssClasses.imageWrapper}>
                    <ImageOutlinedIcon sx={{ fontSize: "6rem" }} />
                    <p>VJ Database</p>
                  </div>
                  <ArrowCircleRightOutlinedIcon sx={{ fontSize: "4rem" }} />
                </div>
                <div
                  className={cssClasses.AddProjectModalContainer}
                  onClick={() => handleSelectDB("Landwoner")}
                >
                  <div className={cssClasses.imageWrapper}>
                    <ImageOutlinedIcon sx={{ fontSize: '6rem' }} />
                    <p>Landowner Database</p>
                  </div>
                  <ArrowCircleRightOutlinedIcon sx={{ fontSize: '4rem' }} />
                </div>
              </div>
            } */}
            {activeStep === 1 &&
              <div style={{
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end'
              }}>
                <div style={{ width: "40%", marginBottom: "1rem" }}>
                  <SearchBar sxStyle={{ width: "100%" }} search={(e) => {
                    setBURows((pre) => {
                      if (e === '') {
                        pre.forEach((ele) => {
                          ele.show = true
                        })
                      } else {
                        pre.forEach((ele) => {
                          if (ele.buId.toString().includes(e.target.value) || ele.projectName.toLowerCase().includes(e.target.value.toLowerCase())) {
                            ele.show = true
                          } else {
                            ele.show = false
                          }
                        })
                      }
                      return [...pre]
                    })
                  }} placeholder={'Search By Project name or buId'} />
                </div>
                <div style={{ height: '100%', width: '100%', display: 'flex' }}>
                  <Datagrid rows={BURows.filter((e) => { return e.show })} columns={BUColumns} />
                </div>
              </div>
            }
            {activeStep === 2 &&
              <div style={{ height: mode === 'edit' ? "89%" : "70%" }} className={cssClasses.heirarchyStyles}>
                <FormControl
                  // onChange={(e) => console.log(e.target.checked)}
                  style={{ minWidth: "32%" }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{
                      background: "#F9FAFB",
                      fontFamily: "Roboto-Regular",
                      fontSize: "1.4rem",
                      fontWeight: "500",
                      lineHeight: "2rem",
                      letterSpacing: "0.20999999344348907px",
                      textAlign: "left",
                      padding: "1.4rem 6.3rem",
                      borderRadius: "1.5rem 1.5rem 0 0",
                      maxWidth: "100%",
                    }}
                  >
                    Wing Selection
                  </FormLabel>
                  <Paper
                    style={{
                      // height: "36rem",
                      height: "100%",
                      maxWidth: "120%",
                      overflow: "auto",
                      marginBottom: "2rem",
                      borderRadius: "0 0 1.5rem 1.5rem",
                    }}
                  >
                    <FormControl style={{ width: "100%" }} component='fieldset' variant='standard'>
                      <FormGroup>
                        {Object.keys(inventory).length === 0 ? (
                          <Typography
                            align="center"
                            style={{
                              fontSize: "1.4rem",
                            }}
                          >
                            No Wings avaliable
                          </Typography>
                        ) : (
                          Object.keys(inventory).map((el) => (
                            <div>
                              {!inventory[el].disabled ?
                                <FormControlLabel
                                  sx={{
                                    background: selectedWing === el ? '#EFF8FF !important' : '',
                                    borderBottom: '1px solid #DADCE0',
                                    width: '100%',
                                    padding: '1rem 0 1rem 2rem',
                                  }}
                                  control={<Checkbox checked={inventory[el].isSelected} name={el} onChange={(e) => {
                                    if (e.target.checked === true) {
                                      setInventory((pre) => {
                                        pre[el].isSelected = true
                                        Object.keys(pre[el].floors).forEach((floor) => {
                                          pre[el].floors[floor].isSelected = true
                                          pre[el].floors[floor].units.forEach((unit, index) => {
                                            pre[el].floors[floor].units[index].isSelected = true
                                          })
                                        })
                                        return { ...pre }
                                      })
                                    } else {
                                      setInventory((pre) => {
                                        pre[el].isSelected = false
                                        Object.keys(pre[el].floors).forEach((floor) => {
                                          pre[el].floors[floor].isSelected = false
                                          pre[el].floors[floor].units.forEach((unit, index) => {
                                            pre[el].floors[floor].units[index].isSelected = false
                                          })
                                        })
                                        return { ...pre }
                                      })
                                    }
                                  }} />}
                                  label={
                                    <Typography
                                      onClick={(e) => { e.preventDefault(); setSelectedWing(el) }}
                                      style={{
                                        fontFamily: 'Roboto-Regular',
                                        fontSize: '1.4rem',
                                        fontWeight: '400',
                                        lineHeight: '2rem',
                                        letterSpacing: '0.20000000298023224px',
                                        textAlign: 'left',
                                        marginLeft: '2.2rem',
                                        width: '85%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                      }}
                                    >
                                      {el}
                                      <ArrowForwardIosIcon
                                        sx={{
                                          color: "#1570EF",
                                        }}
                                      />
                                    </Typography>
                                  }
                                />
                                :
                                <div
                                  style={{
                                    background: selectedWing === el ? '#EFF8FF !important' : '',
                                    borderBottom: '1px solid #DADCE0',
                                    width: '100%',
                                    padding: '1rem 0 1rem 2rem',
                                  }}>
                                  <Typography
                                    onClick={(e) => { e.preventDefault(); setSelectedWing(el) }}
                                    style={{
                                      fontFamily: 'Roboto-Regular',
                                      fontSize: '1.4rem',
                                      fontWeight: '400',
                                      lineHeight: '2rem',
                                      letterSpacing: '0.20000000298023224px',
                                      textAlign: 'left',
                                      marginLeft: '2.2rem',
                                      width: '85%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between'
                                    }}
                                  >
                                    {el}
                                    <ArrowForwardIosIcon
                                      sx={{
                                        color: "#1570EF",
                                      }}
                                    />
                                  </Typography>
                                </div>
                              }
                            </div>
                          ))
                        )}
                      </FormGroup>
                    </FormControl>
                  </Paper>
                </FormControl>

                <FormControl
                  onChange={(e) => console.log(e.target.value)}
                  style={{ minWidth: "32%" }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{
                      background: "#F9FAFB",
                      fontFamily: "Roboto-Regular",
                      fontSize: "1.4rem",
                      fontWeight: "500",
                      lineHeight: "2rem",
                      letterSpacing: "0.20999999344348907px",
                      textAlign: "left",
                      padding: "1.4rem 6.3rem",
                      borderRadius: "1.5rem 1.5rem 0 0",
                      maxWidth: "100%",
                    }}
                  >
                    Floor Selection
                  </FormLabel>
                  <Paper
                    style={{
                      // height: "36rem",
                      height: "100%",
                      maxWidth: "100%",
                      overflow: "auto",
                      marginBottom: "2rem",
                      borderRadius: "0 0 1.5rem 1.5rem",
                    }}
                  >
                    <FormControl style={{ width: "100%" }} component='fieldset' variant='standard'>
                      <FormGroup>
                        {Object.keys(inventory[selectedWing].floors).length === 0 ? (
                          <Typography
                            align='center'
                            style={{
                              fontSize: '1.4rem',
                            }}
                          >
                            No Floors avaliable
                          </Typography>
                        ) : (
                          Object.keys(inventory[selectedWing].floors).map((el) => (
                            <div>
                              {!inventory[selectedWing].floors[el].disabled ?
                                <FormControlLabel
                                  sx={{
                                    background: selectedFloor === el ? "#EFF8FF !important" : '',
                                    borderBottom: '1px solid #DADCE0',
                                    width: '100%',
                                    padding: '1rem 0 1rem 2rem',
                                  }}
                                  control={
                                    <Checkbox
                                      onChange={(e) => {
                                        if (e.target.checked === true) {
                                          setInventory((pre) => {
                                            pre[selectedWing].isSelected = true
                                            pre[selectedWing].floors[el].isSelected = true
                                            pre[selectedWing].floors[el].units.forEach((unit, index) => {
                                              pre[selectedWing].floors[el].units[index].isSelected = true
                                            })
                                            return { ...pre }
                                          })
                                        } else {
                                          setInventory((pre) => {
                                            pre[selectedWing].floors[el].isSelected = false
                                            pre[selectedWing].floors[el].units.forEach((unit, index) => {
                                              pre[selectedWing].floors[el].units[index].isSelected = false
                                            })
                                            let flag = false
                                            Object.keys(pre[selectedWing].floors).forEach((floor) => {
                                              if (pre[selectedWing].floors[floor].isSelected === true) {
                                                flag = true
                                              }
                                            })
                                            if (flag) {
                                              pre[selectedWing].isSelected = true
                                            } else {
                                              pre[selectedWing].isSelected = false
                                            }
                                            return { ...pre }
                                          })
                                        }
                                      }}
                                      checked={inventory[selectedWing].floors[el].isSelected}
                                      name={el}
                                    />
                                  }
                                  label={
                                    <Typography
                                      onClick={(e) => { e.preventDefault(); setSelectedFloor(el) }}
                                      style={{
                                        fontFamily: 'Roboto-Regular',
                                        fontSize: '1.4rem',
                                        fontWeight: '400',
                                        lineHeight: '2rem',
                                        letterSpacing: '0.20000000298023224px',
                                        textAlign: 'left',
                                        marginLeft: '2.2rem',
                                        width: '85%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                      }}
                                    >
                                      {el}
                                      <ArrowForwardIosIcon
                                        sx={{
                                          color: "#1570EF",
                                        }}
                                      />
                                    </Typography>
                                  }
                                />
                                :
                                <div
                                  style={{
                                    background: selectedFloor === el ? "#EFF8FF !important" : '',
                                    borderBottom: '1px solid #DADCE0',
                                    width: '100%',
                                    padding: '1rem 0 1rem 2rem',
                                  }}>

                                  <Typography
                                    onClick={(e) => { e.preventDefault(); setSelectedFloor(el) }}
                                    style={{
                                      fontFamily: 'Roboto-Regular',
                                      fontSize: '1.4rem',
                                      fontWeight: '400',
                                      lineHeight: '2rem',
                                      letterSpacing: '0.20000000298023224px',
                                      textAlign: 'left',
                                      marginLeft: '2.2rem',
                                      width: '85%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between'
                                    }}
                                  >
                                    {el}
                                    <ArrowForwardIosIcon
                                      sx={{
                                        color: "#1570EF",
                                      }}
                                    />
                                  </Typography>
                                </div>
                              }
                            </div>
                          ))
                        )}
                      </FormGroup>
                    </FormControl>
                  </Paper>
                </FormControl>

                <FormControl
                  onChange={(e) => console.log(e.target.value)}
                  style={{ width: "32%" }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{
                      background: "#F9FAFB",
                      fontFamily: "Roboto-Regular",
                      fontSize: "1.4rem",
                      fontWeight: "500",
                      lineHeight: "2rem",
                      letterSpacing: "0.20999999344348907px",
                      textAlign: "left",
                      padding: "1.4rem 6.3rem",
                      borderRadius: "2rem 2rem 0 0",
                      width: "100%",
                    }}
                  >
                    Unit Selection
                  </FormLabel>
                  <Paper
                    style={{
                      // height: "36rem",
                      height: "100%",
                      width: "100%",
                      marginBottom: "2rem",
                      justifyContent: "space-around",
                      textAlign: "center",
                      // maxHeight: '20rem',
                      overflow: "auto",
                      borderRadius: "0 0 1.5rem 1.5rem",
                    }}
                  >
                    {inventory[selectedWing].floors[selectedFloor] && Object.keys(inventory[selectedWing].floors[selectedFloor]).length === 0 && (
                      <Typography
                        align='center'
                        style={{
                          fontSize: '1.4rem',
                        }}
                      >
                        No Units avaliable
                      </Typography>
                    )}
                    {inventory[selectedWing].floors[selectedFloor] && Object.keys(inventory[selectedWing].floors[selectedFloor]).length !== 0 && (
                      <Box className={cssClasses.MainDiv}>
                        <Box className={cssClasses.FlexRow}>
                          {inventory[selectedWing].floors[selectedFloor].units.map((el, index) => (
                            <Box className={cssClasses.DivContainer}>
                              <Box className={cssClasses.InlineDiv}>
                                <FormControl
                                  component='fieldset'
                                  variant='standard'
                                  sx={{ width: '100%' }}
                                >
                                  <FormGroup>
                                    {!el.disabled &&
                                      <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '1rem'
                                      }}>
                                        <FormControlLabel
                                          sx={{
                                            height: "100%",
                                            flexDirection: "row",
                                            justifyContent: "space-around",
                                            marginRight: "0!important",
                                          }}
                                          control={
                                            <Checkbox
                                              onChange={(e) => {
                                                if (e.target.checked) {
                                                  setInventory((pre) => {
                                                    pre[selectedWing].floors[selectedFloor].units[index].isSelected = true
                                                    pre[selectedWing].floors[selectedFloor].isSelected = true
                                                    pre[selectedWing].isSelected = true
                                                    return { ...pre }
                                                  })
                                                } else {
                                                  setInventory((pre) => {
                                                    pre[selectedWing].floors[selectedFloor].units[index].isSelected = false
                                                    if (pre[selectedWing].floors[selectedFloor].units.filter((e) => { return e.isSelected }).length === 0) {
                                                      pre[selectedWing].floors[selectedFloor].isSelected = false
                                                    }
                                                    let flag = false
                                                    Object.keys(pre[selectedWing].floors).forEach((floor) => {
                                                      if (pre[selectedWing].floors[floor].isSelected === true) {
                                                        flag = true
                                                      }
                                                    })
                                                    if (flag) {
                                                      pre[selectedWing].isSelected = true
                                                    } else {
                                                      pre[selectedWing].isSelected = false
                                                    }
                                                    return { ...pre }
                                                  })
                                                }
                                              }}
                                              checked={el.isSelected === true}

                                              name={el.unitNo}
                                              sx={{
                                                alignSelf: "flex-start",
                                                paddingTop: "0!important",
                                                paddingBottom: "0!important",
                                              }}
                                            />
                                          }
                                          label={
                                            <Typography
                                              style={{
                                                fontFamily: "Roboto-Regular",
                                                fontSize: "1.4rem",
                                                fontWeight: "400",
                                                lineHeight: "2rem",
                                                letterSpacing: "0.2px",
                                              }}
                                            >
                                              {/* <div style={{
                                              display: 'flex',
                                              flexDirection: 'column',
                                              gap: '1rem',
                                              alignItems: 'center'
                                            }}> */}
                                              <p style={{ fontSize: "1.4rem" }}>{el.unitNo}</p>
                                              {/* </div> */}
                                            </Typography>
                                          }
                                        />
                                        <div style={{
                                          display: 'flex',
                                          gap: '1rem',
                                          alignItems: 'center'
                                        }}>
                                          <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: '0.5rem'
                                          }}>
                                            <p style={{ fontSize: "1.4rem" }}>{el.unitType}</p>
                                            {el.flatType &&
                                              <p style={{ fontSize: "1.4rem" }}>({el.flatType})</p>
                                            }
                                            <LeadStatusChip icon={<Dot width={"0.5rem"} height={"0.5rem"} />} label={el.UnitStatus} style={{ color: color_schema[el.UnitStatus].color, backgroundColor: color_schema[el.UnitStatus].background }} />
                                          </div>
                                          <div>
                                            {(!el.floor || !el.wingName || !el.unitNo || !el.chargeableArea || !el.saleableArea || !el.unitType) &&

                                              <>
                                                <InfoOutlinedIcon onClick={handleClick} style={{ width: "2rem", height: "2rem", color: "#344054" }}></InfoOutlinedIcon>
                                                <Popover
                                                  id={id}
                                                  open={open}
                                                  anchorEl={anchorEl}
                                                  onClose={handleClose}
                                                  anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                  }}
                                                  style={{ boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)" }}
                                                >
                                                  {!el.chargeableArea &&
                                                    <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>Unit cannot be added \n Chargeable area is null</Typography>}
                                                  {!el.floor &&
                                                    <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>Unit cannot be added <br /> floor no. is null</Typography>}
                                                  {!el.saleableArea &&
                                                    <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>Unit cannot be added <br /> saleable area is null</Typography>}
                                                  {!el.unitNo &&
                                                    <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>Unit cannot be added <br /> unit no. is null</Typography>}
                                                  {!el.unitType &&
                                                    <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>Unit cannot be added <br /> unit type is null</Typography>}
                                                  {!el.wingName &&
                                                    <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>Unit cannot be added <br /> wing name is null</Typography>}
                                                </Popover>
                                              </>
                                            }

                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {el.disabled &&
                                      <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '1rem',
                                        alignItems: 'center'
                                      }}>
                                        <p style={{ fontSize: "1.4rem" }}>{el.unitNo}</p>
                                        <p style={{ fontSize: "1.4rem" }}>{el.unitType}</p>
                                        {el.flatType &&
                                          <p style={{ fontSize: "1.4rem" }}>({el.flatType})</p>
                                        }
                                        <LeadStatusChip icon={<Dot width={"0.5rem"} height={"0.5rem"} />} label={el.UnitStatus} style={{ color: color_schema[el.UnitStatus].color, backgroundColor: color_schema[el.UnitStatus].background }} />
                                      </div>
                                    }
                                  </FormGroup>
                                </FormControl>
                              </Box>
                            </Box>
                            // <Units unit={{ ...el, status: "Available", type: el.unitType }} showCheckbox={() => { return true }} />
                          ))}
                        </Box>
                      </Box>
                    )}
                  </Paper>
                  {/* <div className={cssClasses.unitSelectionBtns}>
                    <p>Select All</p>
                    <span>Clear Selection</span>
                  </div> */}
                </FormControl>
              </div>
            }
            {(activeStep === 1 || activeStep === 2) &&
              <div style={{ justifyContent: mode === 'edit' ? "flex-end" : "space-between" }} className={cssClasses.modalFooterWrapper}>
                {mode !== 'edit' &&
                  <div>
                    {activeStep === 2 && 
                    <>
                      <Button
                      btnName={"Back"}
                      style={{
                        borderRadius: "0.4rem",
                        backgroundColor: "#FFFFFF",
                        color: "#344054",
                        border: "1px solid #D0D5DD",
                        fontSize: "1.4rem",
                      }}
                      padding={"0.8rem 3.6rem"}
                      clicked={() => {
                        setActiveStep((pre) => { return pre - 1 })
                      }}
                    />
                    </>}
                   
                  </div>
                }
                <div className={cssClasses.modalBtnWrapper}>
                  <Button
                    btnName={"Cancel"}
                    style={{
                      borderRadius: "0.4rem",
                      backgroundColor: "#FFFFFF",
                      color: "#98A2B3",
                      border: "none",
                      fontSize: "1.4rem",
                    }}
                    padding={".8rem 2.7rem"}
                    clicked={() => {
                      setMode('add')
                      setOpenAddProjectModal(false);
                      setActiveStep(0);
                      setSelectedWing("");
                      setSelectedFloor("");
                      setSelectedProject("");
                    }}
                  />
                  <Button
                    btnName={activeStep === 1 ? "Next" : "Save"}
                    style={{
                      borderRadius: "0.4rem",
                      backgroundColor: "#007FFF",
                      color: "#FFFFFF",
                      fontSize: "1.4rem",
                      marginLeft: "1rem",
                    }}
                    padding={".8rem 4.7rem"}
                    clicked={() => {
                      if (activeStep === 1) {
                        if (selectedProject === "") {
                          errorTost("Please select a project");
                        } else {
                          getInventory();
                        }
                      } else {
                        let flag = false
                        for (let i = 0; i < Object.keys(inventory).length; i++) {
                          if (inventory[Object.keys(inventory)[i]].isSelected === true) {
                            flag = true
                            break;
                          }
                        }
                        if (flag) {
                          saveInventory();
                        } else {
                          console.log(jdBuid)
                          errorTost("Please select inventory to proceed");
                        }
                      }
                    }}
                  />
                </div>
              </div>
            }
          </>
        }
        footer={"none"}
      />
      <AddModal
        open={openBUList}
        close={() => setOpenBUList(false)}
        title={"Select BUs "}
        subTitle={
          "4 Projects fetched from VJ Database, Select the Project to be added"
        }
        content={
          <div style={{ height: "100%", display: "flex" }}>
            <Datagrid rows={BURows} columns={BUColumns} />
          </div>
        }
        footer={
          <div className={cssClasses.modalFooterWrapper}>
            <Button
              btnName={"Back"}
              style={{
                borderRadius: "0.4rem",
                backgroundColor: "#FFFFFF",
                color: "#344054",
                border: "1px solid #D0D5DD",
                fontSize: "1.4rem",
              }}
              padding={"0.8rem 3.6rem"}
              clicked={() => {
                setOpenBUList(false);
                setOpenAddProjectModal(true);
              }}
            />
            <div className={cssClasses.modalBtnWrapper}>
              <Button
                btnName={"Cancel"}
                style={{
                  borderRadius: "0.4rem",
                  backgroundColor: "#FFFFFF",
                  color: "#98A2B3",
                  border: "none",
                  fontSize: "1.4rem",
                }}
                padding={".8rem 2.7rem"}
                clicked={() => setOpenBUList(false)}
              />
              <Button
                btnName={"Next"}
                style={{
                  borderRadius: "0.4rem",
                  backgroundColor: "#007FFF",
                  color: "#FFFFFF",
                  fontSize: "1.4rem",
                  marginLeft: "1rem",
                }}
                padding={".8rem 4.7rem"}
                clicked={() => {
                  // addProject();
                  setOpenBUList(false);
                  setOpenHierarchy(true);
                }}
              />
            </div>
          </div>
        }
      />
      <AddModal
        open={openLandownerDB}
        close={() => setOpenLandownerDB(false)}
        title={"Merge Database"}
        subTitle={"Select one Database from each table and match them"}
        content={
          <>
            <FormControl onChange={(e) => console.log(e.target.value)}>
              <FormLabel
                id="demo-radio-buttons-group-label"
                sx={{
                  background: "#F9FAFB",
                  fontFamily: "Roboto-Regular",
                  fontSize: "1.4rem",
                  fontWeight: "500",
                  lineHeight: "2rem",
                  letterSpacing: "0.20999999344348907px",
                  textAlign: "left",
                  padding: "1.4rem 6.3rem",
                  borderRadius: "2rem 2rem 0 0",
                }}
              >
                Landowner Database
              </FormLabel>
              <Paper style={{ maxHeight: 200, overflow: "auto" }}>
                <List
                  style={{
                    maxHeight: "18rem",
                    maxWidth: "50%",
                    paddingLeft: "2rem",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                    sx={{
                      padding: "0 4rem",
                    }}
                  >
                    {landOwnerDBList.map((el) => (
                      <FormControlLabel
                        value={el.value}
                        control={<Radio />}
                        label={
                          <Typography
                            style={{
                              fontFamily: "Roboto-Regular",
                              fontSize: "1.6rem",
                              fontWeight: "400",
                              lineHeight: "2rem",
                              letterSpacing: "0.20000000298023224px",
                              textAlign: "left",
                              padding: "2rem 0",
                            }}
                          >
                            {el.label}
                          </Typography>
                        }
                      />
                    ))}
                  </RadioGroup>
                </List>
              </Paper>
            </FormControl>
            <div className={cssClasses.listFooter}>
              <p>
                <strong>VJ Database - 1</strong> matched to{" "}
                <strong>Landowner Database -2</strong>
              </p>
            </div>
          </>
        }
        footer={
          <div className={cssClasses.modalFooterWrapper}>
            <Button
              btnName={"Back"}
              style={{
                borderRadius: "0.4rem",
                backgroundColor: "#FFFFFF",
                color: "#344054",
                border: "1px solid #D0D5DD",
                fontSize: "1.4rem",
              }}
              padding={"0.8rem 3.6rem"}
              clicked={() => {
                setOpenLandownerDB(false);
                setOpenHierarchy(true);
              }}
            />
            <div className={cssClasses.modalBtnWrapper}>
              <Button
                btnName={"Cancel"}
                style={{
                  borderRadius: "0.4rem",
                  backgroundColor: "#FFFFFF",
                  color: "#98A2B3",
                  border: "none",
                  fontSize: "1.4rem",
                }}
                padding={".8rem 2.7rem"}
                clicked={() => setOpenLandownerDB(false)}
              />
              <Button
                btnName={"Save"}
                style={{
                  borderRadius: "0.4rem",
                  backgroundColor: "#007FFF",
                  color: "#FFFFFF",
                  fontSize: "1.4rem",
                  marginLeft: "1rem",
                }}
                padding={".8rem 4.7rem"}
              // clicked={syncClick}
              />
            </div>
          </div>
        }
      />
      <AddModal
        open={openHierarchy}
        close={() => setOpenHierarchy(false)}
        title={"Select Hierarchy"}
        subTitle={"Select the hierarchy of the project"}
        content={
          <div style={{ height: mode === 'edit' ? "89%" : "70%" }} className={cssClasses.heirarchyStyles}>
            <FormControl
              onChange={(e) => console.log(e.target.checked)}
              style={{ minWidth: "32%" }}
            >
              <FormLabel
                id="demo-radio-buttons-group-label"
                sx={{
                  background: "#F9FAFB",
                  fontFamily: "Roboto-Regular",
                  fontSize: "1.4rem",
                  fontWeight: "500",
                  lineHeight: "2rem",
                  letterSpacing: "0.20999999344348907px",
                  textAlign: "left",
                  padding: "1.4rem 6.3rem",
                  borderRadius: "1.5rem 1.5rem 0 0",
                  maxWidth: "100%",
                }}
              >
                Wing Selection
              </FormLabel>
              <Paper
                style={{
                  height: "20rem",
                  maxWidth: "120%",
                  overflow: "auto",
                  marginBottom: "2rem",
                  borderRadius: "0 0 1.5rem 1.5rem",
                }}
              >
                <FormControl component="fieldset" variant="standard">
                  <FormGroup>
                    {wings.length === 0 ? (
                      <Typography
                        align="center"
                        style={{
                          fontSize: "1.4rem",
                        }}
                      >
                        No Wings avaliable
                      </Typography>
                    ) : (
                      wings.map((el) => (
                        <FormControlLabel
                          sx={{
                            borderBottom: "1px solid #DADCE0",
                            width: "100%",
                            padding: "1rem 0 1rem 2rem",
                          }}
                          control={<Checkbox checked={true} name={el.value} />}
                          label={
                            <Typography
                              style={{
                                fontFamily: "Roboto-Regular",
                                fontSize: "1.4rem",
                                fontWeight: "400",
                                lineHeight: "2rem",
                                letterSpacing: "0.20000000298023224px",
                                textAlign: "left",
                                marginLeft: "2.2rem",
                                width: "182%",
                              }}
                            >
                              {el.label}
                              <ArrowForwardIosIcon
                                sx={{
                                  color: "#1570EF",
                                }}
                              />
                            </Typography>
                          }
                        />
                      ))
                    )}
                  </FormGroup>
                </FormControl>
              </Paper>
            </FormControl>

            <FormControl
              onChange={(e) => console.log(e.target.value)}
              style={{ minWidth: "32%" }}
            >
              <FormLabel
                id="demo-radio-buttons-group-label"
                sx={{
                  background: "#F9FAFB",
                  fontFamily: "Roboto-Regular",
                  fontSize: "1.4rem",
                  fontWeight: "500",
                  lineHeight: "2rem",
                  letterSpacing: "0.20999999344348907px",
                  textAlign: "left",
                  padding: "1.4rem 6.3rem",
                  borderRadius: "1.5rem 1.5rem 0 0",
                  maxWidth: "100%",
                }}
              >
                Floor Selection
              </FormLabel>
              <Paper
                style={{
                  height: "20rem",
                  maxWidth: "100%",
                  overflow: "auto",
                  marginBottom: "2rem",
                  borderRadius: "0 0 1.5rem 1.5rem",
                }}
              >
                <FormControl component="fieldset" variant="standard">
                  <FormGroup>
                    {wings[0]?.floors?.length === 0 ? (
                      <Typography
                        align="center"
                        style={{
                          fontSize: "1.4rem",
                        }}
                      >
                        No Floors avaliable
                      </Typography>
                    ) : (
                      wings[0]?.floors?.map((el) => (
                        <FormControlLabel
                          sx={{
                            borderBottom: "1px solid #DADCE0",
                            width: "100%",
                            padding: "1rem 0 1rem 2rem",
                          }}
                          control={
                            <Checkbox
                              // onChange={handleChange}
                              checked={true}
                              name={el.value}
                            />
                          }
                          label={
                            <Typography
                              style={{
                                fontFamily: "Roboto-Regular",
                                fontSize: "1.4rem",
                                fontWeight: "400",
                                lineHeight: "2rem",
                                letterSpacing: "0.20000000298023224px",
                                textAlign: "left",
                                marginLeft: "2.2rem",
                                width: "182%",
                              }}
                            >
                              {el.label}
                              <ArrowForwardIosIcon
                                sx={{
                                  color: "#1570EF",
                                }}
                              />
                            </Typography>
                          }
                        />
                      ))
                    )}
                  </FormGroup>
                </FormControl>
              </Paper>
            </FormControl>

            <FormControl
              onChange={(e) => console.log(e.target.value)}
              style={{ width: "32%" }}
            >
              <FormLabel
                id="demo-radio-buttons-group-label"
                sx={{
                  background: "#F9FAFB",
                  fontFamily: "Roboto-Regular",
                  fontSize: "1.4rem",
                  fontWeight: "500",
                  lineHeight: "2rem",
                  letterSpacing: "0.20999999344348907px",
                  textAlign: "left",
                  padding: "1.4rem 6.3rem",
                  borderRadius: "2rem 2rem 0 0",
                  width: "100%",
                }}
              >
                Unit Selection
              </FormLabel>
              <Paper
                style={{
                  height: "75%",
                  width: "100%",
                  marginBottom: "2rem",
                  justifyContent: "space-around",
                  textAlign: "center",
                  maxHeight: "20rem",
                  overflow: "auto",
                  borderRadius: "0 0 1.5rem 1.5rem",
                }}
              >
                {units.length === 0 ? (
                  <Typography
                    align="center"
                    style={{
                      fontSize: "1.4rem",
                    }}
                  >
                    No Units avaliable
                  </Typography>
                ) : (
                  <Box className={cssClasses.MainDiv}>
                    <Box className={cssClasses.FlexRow}>
                      {units.map((el) => (
                        <Box className={cssClasses.DivContainer}>
                          <Box className={cssClasses.InlineDiv}>
                            {/* <Box className={cssClasses.Title}>{el.label}</Box> */}
                            <FormControl
                              component="fieldset"
                              variant="standard"
                              sx={{ width: "100%", height: "100%" }}
                            >
                              <FormGroup sx={{ height: "100%" }}>
                                <FormControlLabel
                                  sx={{
                                    height: "100%",
                                    flexDirection: "column",
                                    justifyContent: "space-around",
                                    marginRight: "0!important",
                                  }}
                                  control={
                                    <Checkbox
                                      // onChange={handleChange}
                                      checked={true}
                                      name={el.value}
                                      sx={{
                                        alignSelf: "flex-start",
                                        paddingTop: "0!important",
                                        paddingBottom: "0!important",
                                      }}
                                    />
                                  }
                                  label={
                                    <Typography
                                      style={{
                                        fontFamily: "Roboto-Regular",
                                        fontSize: "1.4rem",
                                        fontWeight: "400",
                                        lineHeight: "2rem",
                                        letterSpacing: "0.20000000298023224px",
                                      }}
                                    >
                                      {el.label}
                                    </Typography>
                                  }
                                />
                              </FormGroup>
                            </FormControl>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </Paper>
              <div className={cssClasses.unitSelectionBtns}>
                <p>Select All</p>
                <span>Clear Selection</span>
              </div>
            </FormControl>
          </div>
        }
        footer={
          <div style={{ justifyContent: mode === 'edit' ? "flex-end" : "space-between" }} className={cssClasses.modalFooterWrapper}>
            <Button
              btnName={"Back"}
              style={{
                borderRadius: "0.4rem",
                backgroundColor: "#FFFFFF",
                color: "#344054",
                border: "1px solid #D0D5DD",
                fontSize: "1.4rem",
              }}
              padding={"0.8rem 3.6rem"}
              clicked={() => {
                setOpenHierarchy(false);
                setOpenBUList(true);
              }}
            />
            <div className={cssClasses.modalBtnWrapper}>
              <Button
                btnName={"Cancel"}
                style={{
                  borderRadius: "0.4rem",
                  backgroundColor: "#FFFFFF",
                  color: "#98A2B3",
                  border: "none",
                  fontSize: "1.4rem",
                }}
                padding={".8rem 2.7rem"}
                clicked={() => setOpenHierarchy(false)}
              />
              <Button
                btnName={btnNameFlow}
                style={{
                  borderRadius: "0.4rem",
                  backgroundColor: "#007FFF",
                  color: "#FFFFFF",
                  fontSize: "1.4rem",
                  marginLeft: "1rem",
                }}
                padding={".8rem 4.7rem"}
                clicked={handleSubmit}
              />
            </div>
          </div>
        }
      />
      <div className={cssClasses.wrapperHeader}>
        <div className={cssClasses.headerTitle}>All Projects</div>
        {loggedInUser?.roleId?.accessibleTabs?.Project?.['Add Project']?.isAccessible && (
          <div className={cssClasses.btnWrapper}>
            <Button
              clicked={() => { setMode('add'); setActiveStep(1); setOpenAddProjectModal(true) ; handleSelectDB("VJ") }}
              btnName={'Add Project'}
              btnIcon={<PlusIcon />}
              style={{
                color: "#fff",
                backgroundColor: "#1570EF",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Roboto-Regular",
              }}
              padding={'0.8rem 2.6rem'}
              iconPosition={'left'}
            />
          </div>
        )}
      </div>
      <div className={cssClasses.content}>
        <Box className={cssClasses.totalProjects} margin={"2rem 0"}>

          <Box component={"span"}>{ProjectsCount} Projects</Box>

        </Box>

        <Box margin={"2rem 0"}>
          <Box className={cssClasses.SubTitle}>Sort by</Box>
          <Box className={cssClasses.SubContainer} marginTop={"0.4rem"}>
            <Box className={cssClasses.wrapperSortBy}>
              <Box className={cssClasses.wrapperSortBy}>
                <DropDown
                  list={[
                    "Name Ascending",
                    "Name Descending",
                    "Latest First",
                    "Oldest First",
                  ]}
                  style={{
                    selectedColor: '#175CD3', background: '#E8F0FE'
                  }}
                  selectedValue={drpDownSelectedVal}
                  onChangeSelect={(_value) => {
                    setDrpDownSelectedVal(_value);
                    getAllProjectsFromServer(0, false, search, _value);
                  }}
                />
              </Box>
            </Box>
            <Box width={"25rem"} marginLeft={"auto"}>
              <SearchBar
                id={"StudentSearch"}
                value={search}
                placeholder={"Search by project name"}
                search={debouncedFetchSearchData}
              />
            </Box>
          </Box>
        </Box>
        {Projects?.length > 0 && window.innerWidth > 820 && (
          <div className={cssClasses.gridWrapper}>

            <DataGrid
              rows={Projects}
              columns={ProjectColumns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              page={pageMaintain}
              onPageChange={(_page) => {
                setPageMaintain(_page);
                if (pageNumber < _page) {
                  getMoreData(_page)
                }
              }}
              sx={[dataGridStyles]}
            />
          </div>
        )}
        {Projects?.length > 0 && window.innerWidth <= 820 && (
          <div className={cssClasses.wrapperLeads} id="scrollableDiv">
            <InfiniteScroll
              dataLength={Projects?.length}
              next={getMoreData}
              style={{ display: "flex", flexDirection: "column" }} //To put endMessage and loader to the top.
              hasMore={loadingStatus === 0}
              // loader={<h4>Loading...</h4>}
              scrollableTarget="scrollableDiv"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "98%",
                }}
              >
                {Projects.map((project) => (
                  <Card className={cssClasses.eventWrap}>
                    <div className={cssClasses.eventInfo}>
                      <div className={cssClasses.eventImg} style={{ width: '30%' }}>
                        {project && project.bannerImgUrl ? (
                          <img
                            src={
                              process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                              project.bannerImgUrl
                            }
                            alt="Event"
                          />
                        ) : (
                          <div
                            style={{
                              background: project.isVJ === false ? "#1570EF" : "#FDB022",
                              borderRadius: "50%",
                              textAlign: "center",
                              width: '6rem'
                            }}
                          >
                            <img
                              style={{ margin: "0.8rem 1rem 0.4rem 1rem" }}
                              src={eventIcon}
                              alt=""
                            />
                          </div>
                          // <img src={EventDefaultImg} alt="Event" />
                        )}
                      </div>
                      <div className={cssClasses.eventData} style={{ width: '70%' }}>
                        {/* ??Since we are only getting live events so only one status chip will be there */}

                        <LeadStatusChip
                          label={
                            project.isCompleted ? "Completed" : "Incomplete"
                          }
                          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          style={
                            project.isCompleted
                              ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                              : { color: "#B42318", backgroundColor: "#FEF3F2" }
                          }
                        ></LeadStatusChip>

                        <div className={cssClasses.eventName}>
                          {project.projectName}
                        </div>
                        <div className={cssClasses.eventLaunches}>
                          <p>{`${project.addressLine1} ${project.addressLine2
                            } ${project.addressLine3 === null
                              ? ""
                              : project.addressLine3
                            }`}</p>
                        </div>

                        <div className={cssClasses.viewMore}>
                          <img
                            src={ViewMore}
                            style={{ cursor: "pointer" }}
                            alt={"More"}
                            onClick={() => {
                              goToProject(project.projectId);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
            </InfiniteScroll>
          </div>
        )}

        {NoProjectFound === false && (
          <Box>
            <Box className={cssClasses.noDataMsg}>
              <Box className={cssClasses.emptyIcon}>
                <img src={EmptyState} alt="No Wings" />
              </Box>
              <Box className={cssClasses.noTokensWrapper}>
                <p>No Projects found</p>
                <span>
                  No projects added. Click on the “+ Add Project" button to add a
                  new Project.
                </span>
                {loggedInUser?.roleId?.accessibleTabs?.Project?.['Add Project']?.isAccessible && (
                  <div
                    style={{
                      marginTop: "2rem",
                      // width: "15%",
                    }}
                  >
                    <Button
                      clicked={() => { setMode('add'); setActiveStep(0); setOpenAddProjectModal(true) }}
                      btnName={'Add Project'}
                      btnIcon={<AddIcon style={{ width: '2rem', height: '2rem' }} />}
                      style={{
                        borderRadius: '0.4rem',
                        backgroundColor: '#1570EF',
                        color: '#FFFFFF',
                        fontSize: '1.4rem',
                        fontWeight: '400',
                        lineHeight: '2rem',
                        textAlign: 'center',
                      }}
                      padding={'0.8rem 1.6rem'}
                      iconPosition={'left'}
                    />
                  </div>
                )}
              </Box>
            </Box>
          </Box>
        )}
      </div>
    </div >
  );
}

export default Project;
